import {
  Container,
  Row,
  Col,
  Stack,
  Hidden
} from '@leroy-merlin-br/backyard-react'

import { Shell } from 'shared/components/Shell'

import * as S from './styled'

const EntryKeySkeleton = () => (
  <Container>
    <S.Wrapper>
      <Stack space="mega">
        <Shell width="40vw" height={32} />
        <Shell height={166} borderRadius="mega" />
        <Row justify="space-between">
          <Hidden when={['untilKilo', 'kilo', 'mega']}>
            <Col size={{ giga: 3 }}>
              <Stack space="bit">
                <Shell height={594} />
              </Stack>
            </Col>
          </Hidden>

          <Col size={{ giga: 9 }}>
            {Array(8).fill('shell').map((_, index) => (
              <S.WrapperInline key={index}>
                <Shell height={594} />
                <Shell height={594} />
                <Shell height={594} />
                <Shell height={594} />
              </S.WrapperInline>
            ))}
          </Col>
        </Row>
      </Stack>
    </S.Wrapper>
  </Container>
)

export default EntryKeySkeleton
